export default {
      id: "barometricPressure-usage",
      viewBox: "0 0 16.72 21.523",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#barometricPressure",
      toString: function () {
        return this.url;
      }
    }